<template>
    <NuxtLayout name="main" dark class="bg-[#F7F6FB]">
        <div class="container">
            <section class="py-[40px] max-lg:py-[24px]">
                <project-route target="_self" :to="{ name: 'Home' }">{{ $t("Home.Name") }}</project-route> >
                <project-route target="_self" :to="{ name: 'News' }">{{ $t("News") }}</project-route> >
                <project-route target="_self" :to="{ name: 'News', params: { type: route.params.type } }"> {{ data.type }}</project-route>
            </section>
            <div class="flex items-start">
                <div :class="css.aside" class="sticky top-0 shrink-0 w-[300px]">
                    <section>
                        <div :class="css.name"><ui-icon name="news" />{{ $t("News") }}</div>
                        <div class="mt-[20px]">
                            <ProjectRoute
                                class="flex items-center justify-between py-[12px] t-border-b-[#eeeeee]"
                                v-for="value in filters"
                                :to="{ name: 'News', params: { type: value.route } }"
                                target="_blank">
                                <div>
                                    {{ value.label }}<span class="ml-[16px]">({{ value.count }})</span>
                                </div>
                                <ui-icon name="arrow" class="-t-rotate-90"></ui-icon>
                            </ProjectRoute>
                        </div>
                    </section>
                    <section v-if="recommends.length">
                        <div :class="css.name"><ui-icon name="article" />{{ $t("RelatedArticles") }}</div>
                        <div class="mt-[20px]">
                            <ProjectRoute
                                class="flex items-center justify-between pt-[12px] text-main underline-offset-2 underline leading-[28px] hover:text-[#9f50cb]"
                                v-for="value in recommends"
                                :to="value.route"
                                target="_blank">
                                >> {{ value.name }}
                            </ProjectRoute>
                        </div>
                    </section>
                    <section v-if="tools_recommends.length">
                        <div :class="css.name"><ui-icon name="ai" />{{ $t("RecommendedAITools") }}</div>
                        <div class="m-[-6px] mt-[32px] flex flex-wrap">
                            <ProjectRoute
                                class="py-[2px] px-[12px] m-[6px] text-main t-border-[#DDDDEA] leading-[28px] rounded-[4px] hover:text-[#9f50cb]"
                                v-for="value in tools_recommends"
                                :to="value.route"
                                target="_blank">
                                {{ value.name }}
                            </ProjectRoute>
                        </div>
                    </section>
                    <section v-if="database.length">
                        <div :class="css.name"><ui-icon name="database" />{{ $t("Database") }}</div>
                        <div class="m-[-6px] mt-[32px] flex flex-wrap">
                            <ProjectRoute
                                class="py-[2px] px-[12px] m-[6px] text-main t-border-[#DDDDEA] leading-[28px] rounded-[4px] hover:text-[#9f50cb]"
                                v-for="value in database"
                                :to="value.route"
                                target="_blank">
                                {{ value.name }}
                            </ProjectRoute>
                        </div>
                    </section>
                </div>

                <div class="flex-1 ml-[20px] pt-[56px] px-[64px] pb-[64px] bg-white rounded-[4px]" v-if="data">
                    <section class="pb-[48px] t-border-b-uicolor4">
                        <h1 class="text-[32px] text-emphas leading-[48px] font-bold">{{ data.title }}</h1>
                        <div class="flex items-center justify-between mt-[20px]">
                            <div class="flex items-center flex-wrap text-[#898c98] gap-x-[48px]">
                                <p><ui-icon name="date2" class="mr-[8px]" />{{ $t("Date") }}: {{ data.date }}</p>
                                <p><ui-icon name="classification" class="mr-[8px]" /> {{ $t("Classification") }}: {{ data.type }}</p>
                            </div>
                            <div class="flex">
                                <!-- * 分享 -->
                                <DefaultShare class="ml-[16px]" :origin="data">
                                    <ui-button size="default"><ui-icon name="share" class="mr-[4px]" /> 分享</ui-button>
                                    <template #content>
                                        <div class="flex items-center w-full">
                                            <div class="min-w-0 flex-1">
                                                <div>{{ data.type }}</div>
                                                <div class="font-bold line-clamp-3 whitespace-pre-wrap">
                                                    {{ data.title }}
                                                </div>
                                            </div>
                                            <div class="shrink-0 ml-[16px] w-[136px] h-[74px] rounded-[8px] overflow-hidden" v-if="data.cover.src">
                                                <img class="w-full h-full object-cover" :src="data.cover.src" :alt="data.cover.alt" />
                                            </div>
                                        </div>
                                    </template>
                                </DefaultShare>
                                <!-- * 收藏 -->
                                <div class="ml-[16px]">
                                    <Favorites size="small"></Favorites>
                                </div>
                            </div>
                        </div>
                        <!-- * 标签 -->
                        <div class="mt-[20px] flex flex-wrap gap-[16px]" v-if="data.tags.length">
                            <div v-for="value in data.tags" class="bg-[#FDF1FF] px-[20px] rounded-full leading-[40px] max-w-[600px] line-clamp-1">
                                {{ value }}
                            </div>
                        </div>
                    </section>
                    <!-- * 内容 -->
                    <section class="pt-[48px]">
                        <div v-html="data.content"></div>
                    </section>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>
<script lang="ts" setup>
//* 组件库
import { UiIcon, UiButton } from "various-ui";
//* 公共组件
import { Favorites, DefaultShare } from "@/components/controls";
//* route
const route = useRoute();
//* 样式
import css from "./index.module.less";
const clsxs = {
    share: clsx.default(
        "cursor-pointer t-border-uicolor4  h-[32px] rounded-full flex items-center justify-center  text-[#878787] t-delay hover:t-border-main hover:text-main"
    ),
};

//* 获取初始数据
const options = await api.server("NewsDetails", "/api/news/details", {
    method: "POST",
    data: { path: route.path.replace(/^\/zh\//, ""), token: route.query.token },
});
const { data, filters, recommends, tools_recommends, database } = options.value || {};
</script>
